import { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { g as getRandomValue, O as OPTION_IMAGES_POOL } from '../../defaults-0542c304.js';
import { PollPropTypes } from './types.js';
import 'wix-rich-content-common/libs/imageUtils';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const PollContext = React.createContext({});
const withPoll = (WrappedComponent) => (props) => {
  return /* @__PURE__ */ React.createElement(PollContext.Consumer, null, (contextValue) => {
    return /* @__PURE__ */ React.createElement(WrappedComponent, __spreadValues(__spreadValues({}, props), contextValue));
  });
};
class PollContextProvider extends PureComponent {
  constructor(props) {
    var _a;
    super(props);
    __publicField(this, "state", {
      changePollTitle: this.changePollTitle.bind(this),
      updatePollOption: this.updatePollOption.bind(this),
      addOption: this.addOption.bind(this),
      removeOption: this.removeOption.bind(this),
      changePollImage: this.changePollImage.bind(this),
      fetchPoll: this.fetchPoll.bind(this),
      vote: this.vote.bind(this),
      unvote: this.unvote.bind(this),
      getVoters: this.getVoters.bind(this),
      poll: this.props.poll
    });
    __publicField(this, "syncPoll", async () => {
      let dto;
      const poll = this.populateWithData(this.state.poll);
      if (poll.id) {
        dto = await this.pollApiClient.updatePoll(poll);
      } else {
        dto = await this.pollApiClient.createPoll(poll);
      }
      this.props.setPoll(dto);
      console.debug("polls publish callback");
    });
    this.pollApiClient = (_a = props.settings) == null ? void 0 : _a.pollServiceApi;
  }
  componentWillReceiveProps(props) {
    var _a;
    if (!((_a = props.settings) == null ? void 0 : _a.pollServiceApi) && props.settings.siteToken !== this.props.settings.siteToken) {
      this.fetchPoll();
    }
    if (JSON.stringify(props.poll) !== JSON.stringify(this.props.poll)) {
      this.setState(() => ({ poll: props.poll }));
    }
  }
  componentDidMount() {
    const { editorEvents } = this.props;
    editorEvents == null ? void 0 : editorEvents.subscribe("plugin:publish", this.syncPoll);
  }
  componentWillUnmount() {
    var _a;
    (_a = this.props.editorEvents) == null ? void 0 : _a.unsubscribe("plugin:publish", this.syncPoll);
  }
  async fetchPoll() {
    var _a, _b;
    if (!this.state.poll.id) {
      return;
    }
    const poll = await this.pollApiClient.fetchPoll(this.state.poll.id);
    (_b = (_a = this.props).setPoll) == null ? void 0 : _b.call(_a, poll);
    this.setState(() => ({ poll }));
  }
  populateWithData(poll) {
    const { t } = this.props;
    poll.title = poll.title || t("Poll_Editor_Question_Placeholder");
    poll.options = poll.options.map((option) => __spreadProps(__spreadValues({}, option), {
      title: option.title || t("Poll_Editor_Answer_Placeholder")
    }));
    return poll;
  }
  updatePoll(poll) {
    this.props.setPoll(Object.assign({}, this.state.poll, poll));
  }
  async vote(optionId) {
    const poll = await this.pollApiClient.vote(this.state.poll.id, optionId);
    this.setState({ poll });
  }
  async unvote(optionId) {
    const poll = await this.pollApiClient.unvote(this.state.poll.id, optionId);
    this.setState({ poll });
  }
  getVoters(optionId, params) {
    return this.pollApiClient.getVoters(this.state.poll.id, optionId, params);
  }
  changePollTitle(title) {
    return this.updatePoll({ title });
  }
  changePollImage(url) {
    const imageData = { image: { src: { url } } };
    return this.updatePoll(imageData);
  }
  updatePollOption(index, option) {
    const poll = cloneDeep(this.state.poll);
    poll.options[index] = option;
    return this.updatePoll({ options: poll.options });
  }
  addOption() {
    const poll = cloneDeep(this.state.poll);
    const imageData = {
      image: {
        src: {
          url: getRandomValue(OPTION_IMAGES_POOL)
        }
      }
    };
    poll.options.push(__spreadValues({
      title: ""
    }, imageData));
    return this.updatePoll({ options: poll.options });
  }
  removeOption(index) {
    const poll = cloneDeep(this.state.poll);
    poll.options.splice(index, 1);
    return this.updatePoll({ options: poll.options });
  }
  render() {
    const { children } = this.props;
    return /* @__PURE__ */ React.createElement(PollContext.Provider, { value: this.state }, children);
  }
}
__publicField(PollContextProvider, "propTypes", {
  editorEvents: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  }),
  settings: PropTypes.shape({
    siteToken: PropTypes.string,
    isWebView: PropTypes.bool,
    getSiteMembers: PropTypes.func,
    pollServiceApi: PropTypes.object
  }),
  poll: PropTypes.shape(PollPropTypes),
  setPoll: PropTypes.func,
  children: PropTypes.any,
  t: PropTypes.func
});

export { PollContext, PollContextProvider, withPoll };
//# sourceMappingURL=PollContext.js.map
